<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet_box_specs" style="width: 100%; height:100%">
		<div *ngIf="!hasData">
			<div class="creative-title">
				<label>{{ sectiontitle }}</label>
			</div>
			<div class="parameters-div" style="padding: 15px 20px">
				No data found
			</div>
		</div>

		<div *ngIf="hasData">
			<div class="creative-title primary-color">
				<label [title]="currentNetworkData?.creativeName">
					<b>{{ sectiontitle }}</b>
				</label>
				<!-- *ngIf="totalCreatives!=0 && downloadConfiguration && downloadConfiguration.enableDownload" -->
				<a href="#" class="datatable_download_icon" (click)="downloadDataInCSV($event)" target="_blank">
					<img src="../../../../../assets/creative-assets/download.svg">
				</a>
			</div>

			<div class="carousel-area" [ngClass]="{'pointerNone': showTableLoad}" *ngIf="hasData && sortedNetworks.length > 0">
				<div class="creative-carousel">
					<span (click)="slideLeft()" [ngClass]="{'pointerNone': showTableLoad}" class="u-cursor-pointer" *ngIf="hasData && sortedNetworks.length > 1">
						<img src="../../../../../assets/creative-assets/left-arrow.svg" class="left-arrow">
					</span>
					<ngx-carousel-3d [slides]="sortedNetworks" [slideClass]="'netWorksAndShows'" [options]="options" class="col-12" #carousel>
						<div *ngFor="let slide of sortedNetworks; let i = index">
							<div class="carouselImg" (click)="slideClicked(i)" [ngClass]="{'pointerNone': showTableLoad}">
								<img *ngIf="slide.networkLogo !== ''" class="slide-img" src="{{ slide.networkLogo }}" width="270" alt="" />
								<div class="network-logo-div" *ngIf="slide.networkLogo === ''">
									<span class="network-logo-name">{{slide.networkName}}</span>
								</div>
							</div>
						</div>
					</ngx-carousel-3d>
					<span (click)="slideRight()" [ngClass]="{'pointerNone': showTableLoad}" class="u-cursor-pointer" *ngIf="hasData && sortedNetworks.length > 1">
						<img src="../../../../../assets/creative-assets/right-arrow.svg" class="right-arrow ">
					</span>

					<div class="text-align-center">
						<h4 class="creative-name">
							{{ currentNetworkData?.networkName }}
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="u-shadow-mini pos-relative">
	<app-loader [showLoader]="showTableLoad"></app-loader>
	<div [ngClass]="{ 'analytics-datatable-scrollable': isVerticalScrollable }" style="width: 100%; height:100%">
		<ngx-datatable
			style="height: 100%;"
			class="datatable v5datatable networks-shows-table"
			[columns]="dataTableObj.columns"
			[rows]="dataTableObj.data"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="footerHeight"
			[rowHeight]="rowHeight"
			[reorderable]="reorderable"
			[scrollbarV]="isVerticalScrollable"
		>
			<ng-template ngFor let-column [ngForOf]="dataTableObj.columns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span
							(click)="sort()"
							style="cursor: pointer;"
							*ngIf="!column.columnHasTooltip; else elseBlock"
						>
							{{ colHeader.name }}
						</span>
						<ng-template #elseBlock>
							<span style="cursor: pointer;">
								<span
									(click)="sort()"
									appTooltip
									title="Tooltip"
									[title]="column.columnTooltip"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ colHeader.name }}
								</span>
							</span>
						</ng-template>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
		</ngx-datatable>
	</div>
</div>